export default __webpack_public_path__ + "static/media/property_257.2b0666cb.png";